export interface RoomPrivacyBooking {
  room_id: string;
  is_private?: boolean;
  status: string;
  start_time: string;
  end_time: string;
}

/** Never forward access codes or attendee data to the world. Times are UTC epoch seconds. */
export function roomPrivacySnapshot(bookings: RoomPrivacyBooking[]) {
  return { bookings: bookings.flatMap(booking => {
    const match = /^intersect-room-0([1-5])$/.exec(booking.room_id);
    const start = Date.parse(booking.start_time) / 1000;
    const end = Date.parse(booking.end_time) / 1000;
    return match && booking.is_private && booking.status !== 'cancelled' &&
      Number.isFinite(start) && Number.isFinite(end) && end > start
      ? [{ stageIndex: Number(match[1]), start: Math.floor(start), end: Math.ceil(end) }] : [];
  }) };
}
